import React, { useRef } from "react";
import { Affix, Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";
import AddOrUpdateForm from "./AddOrUpdateForm";

const AddOrUpdateNewTNATemplate = (props) => {
  const { width, isEdit } = props;

  const propertyFormRef = useRef(null);
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/tanda/new-template");
  };

  const submitForm = () => {
    propertyFormRef.current.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="T&A Template"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={discardForm}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={submitForm}>
                {isEdit ? "Update Template" : "Add Template"}
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddOrUpdateForm ref={propertyFormRef} isEdit={isEdit} />
    </>
  );
};

export default AddOrUpdateNewTNATemplate;
